import axios from 'axios';
import { URLS } from 'modules/api/constants';

export const getOpenStreetMapPoi = async (searchValue, countryNames) => {
  const escapeForOverpassRegex = (input) => input.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  const escapedInput = escapeForOverpassRegex(searchValue);
  const areaAssignments = countryNames.map((country, i) => `area["name:en"="${country}"]->.area${i};`).join('\n');
  const areaMerge = `(${countryNames.map((_, i) => `.area${i}`).join(';')};)->.searchArea;`;

  const query = `
    [out:json][timeout:360];
    ${areaAssignments}
    ${areaMerge}
    (
      node[amenity~"^${escapedInput}$",i](area.searchArea);
      node[brand~"^${escapedInput}",i](area.searchArea);
      node[name~"^${escapedInput}",i](area.searchArea);
      node[shop~"^(supermarket|grocery|convenience|hypermarket)$"][name~"^${escapedInput}",i](area.searchArea);
      way[amenity~"^${escapedInput}$",i](area.searchArea);
      way[brand~"^${escapedInput}",i](area.searchArea);
      way[name~"^${escapedInput}",i](area.searchArea);
      way[shop~"^(supermarket|grocery|convenience|hypermarket)$"][name~"^${escapedInput}",i](area.searchArea);
    );
    out center;
  `;

  const response = await axios.get(`${URLS().OPEN_STREET_MAP_OVERPASS()}?data=${encodeURIComponent(query)}`);

  return response.data?.elements ?? [];
};
